import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Routing from "./Routers/Routing";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


function App() {
  return (
    <>
      <Routing />
    </>
  );
}

export default App;
